import service from './request'
// import qs from "qs";



//登录 
export const login = (params) => service.post('/auth/login', {
  username: params[0],
  password: params[1]
}
  // , {
  //     headers: {
  //         'Content-Type': 'application/json;charset=utf-8'
  //     }
  // }

)


//获取案件列表
export const getcaselist = (params) => service.get('/caseType', { params: params })

//新增案件
export const addcase = (params) => service.post('/caseType', params)

//删除案件
export const deletecase = (params) => service.delete('/caseType/' + params[0])

//修改案件
export const changecase = (params) => service.put('/caseType/' + params[0], {
  typeName: params[1],
  id: params[2],
})


//获取问题列表
export const getquestionlist = (params) => service.get('/templateQuestion', { params: params })

//新增问题
export const addquestion = (params) => service.post('/templateQuestion', params)


//删除问题
export const deletequestion = (params) => service.delete('/templateQuestion/' + params[0])

//修改问题
export const changequestion = (params) => service.put('/templateQuestion/' + params[0], {
  content: params[1],
  id: params[2],
})

//获取询问管理列表
export const getrecordlist = (params) => service.get('/record', { params: params })


//获取用户列表
export const getuserlist = (params) => service.get('/user', { params: params })

//获取角色列表
export const getrolelist = (params) => service.get('/role', { params: params })

//获取权限列表
export const getpowerlist = (params) => service.get('/permission', { params: params })

//新增角色
export const addrole = (params) => service.post('/role', params)

//删除角色
export const deleterole = (params) => service.delete('/role/' + params[0])

//新增用户
export const addUser = (params) => service.post('/user', params)

//删除用户
export const deleteperson = (params) => service.delete('/user/' + params[0])

//根据id获取用户
export const getuserById = (params) => service.get('/user/' + params[0])

//修改用户
export const edituser = (params) => service.put('/user/' + params[0], {
  nickname: params[1],
  id: params[2],
  phone: params[3],
  certNo: params[4],
})

//获取当前用户信息
export const currentUser = (params) => service.get('/user/curr', { params: params })

//获取权限树
export const powertree = () => service.get('permission/tree')
//获取单个角色权限树
export const powerroletypetree = (id) => service.get(`role/perm?roleId=${id}`)

export const addrolepoewr = (params) => service.post(`role/perm`, params,)

// 修改密码
export const changepassword = (params) => service.get(`user/reSetPassword?username=${params[0]}&oldPassword=${params[1]}&newPassword=${params[2]}`, {
  username: params[0],
  oldPassword: params[1],
  newPassword: params[2],
})


//获取部门列表
export const getdeptlist = (params) => service.get('/dept', { params: params })

//新增部门
export const adddept = (params) => service.post('/dept', params)


//删除部门
export const deletedept = (params) => service.delete('/dept/' + params[0])

//修改部门
export const changedept = (params) => service.put('/dept/' + params[0], {
  content: params[1],
  id: params[2],
})


//新增询问笔录
export const addrecord = (params) => service.post('/record', params)


//删除询问笔录
export const deleterecord = (params) => service.delete('/record/' + params[0])

//通过id查找对应询问笔录
export const findrecord = (params) => service.get('/record/' + params[0])


//修改询问笔录
export const changerecord = (params) => service.put('/record/' + params[0], params[1])
// 结束询问笔录
export const setFinishrecord = (id) => service.put(`record/${id}/complete`)
// 修改是否可见
export const setVisible = (id, visibility) => service.put(`/record/${id}/visibility?visibility=${visibility}`)
//预览PDF
export const previewpdf = (params) => service.get('/record/' + params[0] + '/preview/pdf')


//下载word
export const downloadword = (params) => service.get('/record/' + params[0] + '/export/word')

//发送短信
export const sendsms = (params) => service.get('/sms/record/notification', { params: params })
// 发送签名短信
export const sendsmsforSign = (params) => service.get('/sms/notification/sign', { params: params })
// 视频短信
export const sendsmsforVideo = (params) => service.get('/sms/notification/video', { params: params })





//添加电子签名
export const getfile = (params) => service.post('/record/' + params[0] + '/sign', {
  id: params[0],
  file: params[1],
}, {
  headers: {
    'Content-Type': 'multipart/form-data;charset=utf-8'
  }
})


//解散房间
export const DismissRoom = (params) => service.post('https://trtc.tencentcloudapi.com/', params, {
  headers: {
    'Content-Type': 'application/json',

  }
})


// //结束录制
// export const finishvideo = (params) => service.put('/record/' + params[0] + '/finish?roomId=' + params[1], {
//     headers: {
//         'Content-Type': 'multipart/form-data'
//     }
// })


//结束录制
export const finishvideo = (params) => service.post('/trtc/recording/room/dismiss', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})




//开始录制
export const startrecording = (params) => service.post('/trtc/recording/start', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


//结束录制
export const stoprecording = (params) => service.post('/trtc/recording/stop', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//模板问题排序
export const movetemplateQuestion = (params) => service.put('/templateQuestion/move', params)


//获取userid对应的签名
export const getuserSign = (params) => service.get('/trtc/userSign', { params: params }, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})










//获取单位列表
export const getunitList = (params) => service.get('/api/v1/unit/getList', { params: params })


//获取用户列表
export const getuser = (params) => service.get('/api/v1/admin/account/get', { params: params })

//获取当前用户
export const getpersonal = (params) => service.get('/api/v1/admin/personal/get', {
  id: params[0],
})



//获取角色列表
export const getrole = (params) => service.get('/api/v1/admin/role/get', {
  id: params[0],
})




//设备日志查询
export const getdevicelog = (params) => service.get('/api/v1/log/device/get', { params: params })

//操作日志查询
export const getactivitylog = (params) => service.get('/api/v1/log/activity/get', { params: params })

//空气道传感器列表
export const getairList = (params) => service.get('/air/getList', { params: params })

//空气道传感器上下线记录
export const aironlinestatus = (params) => service.get('/air/onlinestatus', { params: params })

//插座列表
export const getboardList = (params) => service.get('/board/getList', { params: params })

//插座工作记录
export const readinglist = (params) => service.get('/reading/realWithPage', { params: params })

//插座带分页设备上下线
export const boardonlinestatus = (params) => service.get('/board/onlinestatusWithPage', { params: params })

//合并后的读数列表
export const reading = (params) => service.get('/reading', { params: params })


//插座检测列表
export const detectionboard = (params) => service.get('/detection/board', { params: params })



//水表设备上下线
export const wateronlinestatus = (params) => service.get('/api/v1/device/onlinestatus', { params: params })

//水表列表
export const getwaterList = (params) => service.get('/api/v1/device/getList', { params: params })


//水表工作记录
export const getwaterhistory = (params) => service.post('/api/v1/device/getHistory', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//水表记录详情 一天有好几条
export const getHistoryDetail = (params) => service.post('/api/v1/device/getHistoryDetail', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


//报告
export const getreportList = (params) => service.get('/report/getList', { params: params })

//报告
export const getreportdetail = (params) => service.get('/report/getReport', { params: params })

//告警列表
export const getalarmdetail = (params) => service.get('/alarm', { params: params })


//级联查询单位省市区
export const getunitTree = (params) => service.get('/api/v1/admin/unitTree/get', { params: params })

//人员列表查询
export const getpersonList = (params) => service.get('/api/v1/person/getList', { params: params })



//获取权限列表
export const getmenuList = (params) => service.get('/api/v1/menu/list', { params: params })

//删除权限菜单
export const deletemenu = (params) => service.get('/api/v1/menu/delete', { params: params })


//删除人员
export const deletepersons = (params) => service.get('/api/v1/person/delete', { params: params })





//空气质量运行详情
export const airreading = (params) => service.get('/air/readingWithPage', { params: params })

//查询历史记录
export const airreadingdate = (params) => service.get('/air/reading', { params: params })




//级联查询省市区(不带单位的)
export const getareaTree = (params) => service.get('/api/v1/admin/areaTree/get', { params: params })


//删除空气道设备
export const airdelete = (params) => service.get('/air/delete', { params: params })

//删除插座
export const boarddelete = (params) => service.get('/board/delete', { params: params })


//健康码扫码数据
export const healthScan = (params) => service.get('/api/v1/healthScan', { params: params })


//加载对应角色菜单列表树
export const getroleMenuTreeselect = (params) => service.get('/api/v1/menu/roleMenuTreeselect/get', { params: params })





//修改用户状态
export const changestatus = (params) => service.post('/api/v1/admin/account/update', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})



//新增或者修改单位
export const addunit = (params) => service.post('/api/v1/unit/add', params)

//添加权限
export const addmenu = (params) => service.post('/api/v1/menu/add', params)

//修改菜单
export const editmenu = (params) => service.post('/api/v1/menu/edit', params)


//删除单位
export const deleteunit = (params) => service.post('/api/v1/unit/delete', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//删除水表
export const watchdelete = (params) => service.post('/api/v1/device/delete', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})





//权限分配修改
export const updateroleMenu = (params) => service.post('/api/v1/menu/insertRoleMenu', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})



//新增用户
export const addperson = (params) => service.post('/api/v1/person/add', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//新增空气设备
export const addair = (params) => service.post('/air/add', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


//新增水表
export const addwatch = (params) => service.post('/api/v1/device/add', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//新增插座设备
export const insertboard = (params) => service.post('/board/insert', params)

//修改空气设备
export const updateair = (params) => service.post('/air/update', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


//根据名字或者身份证获取员工健康证信息
export const getByNameOrId = (params) => service.post('/api/v1/person/getByNameOrId', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


//获取isc
export const getIscArgs = (params) => service.post('/api/v1/camera/getIscArgs', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//新增编辑摄像头
export const addcamera = (params) => service.post('/api/v1/camera/add', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

//删除单个摄像头
export const deletecamera = (params) => service.post('/api/v1/camera/delete', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})


//是否推送某条消息
export const addPushalarm = (params) => service.put('/alarm/addPush', params, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})





//摄像头列表查询
export const getcamearList = (params) => service.get('/api/v1/camera/getList', { params: params })

//摄像头设备上下线查询
export const getOnlineList = (params) => service.get('/api/v1/camera/getOnlineList', { params: params })


//获取ISC网点树形列表
export const getIscAreaList = (params) => service.get('/api/v1/camera/getIscAreaList', { params: params })

//根据ISC网点获取设备列表
export const getIscCamerasByIndexCode = (params) => service.get('/api/v1/camera/getIscCamerasByIndexCode', { params: params })


//修改空气质量指标
export const updateAirConfig = (params) => service.get('/air/updateAirConfig', { params: params })


//获取空气质量指标
export const getAirConfig = (params) => service.get('/air/getAirConfig', { params: params })

//添加日志
export const addlogoperate = (params) => service.post("https://ivatest.terabits.cn:9011/log/operate", params)


//查询日志
export const logoperatelist = (params) => service.get("https://ivatest.terabits.cn:9011/log/operate", { params: params })

// 获取取证列表
export const getAttestList = (params) => service.get('/evidence', { params })
// 查看pdf
export const checkPdf = (id) => service.get(`/evidence/${id}/preview/pdf`)




